<template>
    <div>
        <footer class="w-100 d-inline-block 
        footer-bg">
        <!-- <div class="fixed-call-btn position-relative d-xl-inline-block d-none">
            <a class="text-white" href="javascript:void(0)" @click="openCall">
                <img src="@/assets/images/call-icon.svg" alt="picture">
            </a>
        </div> -->
        <!-- <div class="fixed-call-btn-2 
        position-relative d-xl-inline-block d-none">
            <a class="text-white" href="javascript:void(0)" @click="openWhatsApp">
                <i class="fa fa-whatsapp text-size-24 text-full-24" aria-hidden="true"></i>
            </a>
        </div> -->
            <div class="container autoContent">
                <div class="row margin-top4 margin-xl-bottom4">
                    <div class="col-xl-2 col-12 
                    col-sm-3 col-md-3 col-lg-2">
                        <div class="footer-logo w-100 d-inline-block">
                            <router-link to="/">
                                <img :src="footerLogoSrc" alt="picture">
                            </router-link>
                        </div>
                        <ul class="w-100 d-inline-block footer-services margin-top-4 
                        ps-0 mb-0">
                            <li class="d-inline-block padding-bottom-2 w-100">
                                <a class="text-size-14 text-white d-inline-block inter-regular-family text-full-12" :href="footerFacebookUrl" target="_blank">
                                    <span class="d-inline-block text-center rounded-5 me-2 facebook-icon">
                                        <i aria-hidden="true" class="fa fa-facebook"></i>
                                    </span>
                                    Facebook
                                </a>
                            </li>
                            <li class="d-inline-block padding-bottom-2 w-100">
                                <a class="text-size-14 text-white d-inline-block inter-regular-family text-full-12" :href="footerInstagramUrl" target="_blank">
                                    <span class="d-inline-block text-center rounded-5 me-2 instagram-icon">
                                        <i aria-hidden="true" class="fa fa-instagram"></i>
                                    </span>
                                    Instagram
                                </a>
                            </li>
                            <li class="d-inline-block padding-bottom-2 w-100">
                                <a class="text-size-14 text-white d-inline-block inter-regular-family text-full-12" :href="footerTwitterUrl" target="_blank">
                                    <span class="d-inline-block text-center rounded-5 me-2 twitter-icon">
                                        <i aria-hidden="true" class="fa fa-twitter margin-top-1"></i> 
                                    </span>
                                    Twitter
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div class="col-xl-2 col-12 mt-xl-0 mt-4 col-sm-4 mt-sm-0 col-md-4 col-lg-2 d-xl-block d-none d-md-block d-sm-block d-lg-block">
                        <div class="w-100 d-inline-block padding-bottom-2">
                            <span class="text-white fw-bold text-size-15 spacing-2 family-guy text-full-15">Links
                            </span>
                        </div>
                        <ul class="w-100 d-inline-block ps-0 footer-services">
                            <li class="d-inline-block padding-bottom-1 w-100">
                                <a class="text-size-14 text-white d-inline-block inter-regular-family text-full-12" href="javascript:void(0)">
                                    Shop
                                </a>
                            </li>
                            <li class="d-inline-block padding-bottom-1 w-100">
                                <router-link class="text-size-14 text-white d-inline-block inter-regular-family text-full-12" to="/blog/" exact-active-class="active-link">
                                    Blog
                                </router-link>
                            </li>
                            <li class="d-inline-block padding-bottom-1 w-100">
                                <router-link class="text-size-14 text-white d-inline-block inter-regular-family text-full-12" to="/about-us" exact-active-class="active-link">
                                    About Us
                                </router-link>
                            </li>
                            <li class="d-inline-block padding-bottom-1 w-100">
                                <router-link class="text-size-14 text-white d-inline-block inter-regular-family text-full-12" to="/contact-us" exact-active-class="active-link">
                                    Contact Us
                                </router-link>
                            </li>
                        </ul>
                    </div>
                    <div class="col-xl-2 col-6 
                    col-sm-4 col-md-4 col-lg-2 mt-xl-0 mt-4 mt-sm-0">
                        <div class="w-100 d-inline-block 
                        padding-bottom-2">
                            <span class="text-white fw-bold text-size-15 spacing-2 family-guy text-full-15">Services
                            </span>
                        </div>
                        <ul class="w-100 d-inline-block ps-0 footer-services">
                            <li v-for="category in footerCategories" :key="category.id" class="d-inline-block padding-bottom-1 w-100">
                                <router-link
                                    class="text-size-14 text-white d-inline-block inter-regular-family text-full-12"
                                    :to="footerServiceLink(category)"
                                    exact-active-class="active-link"
                                >
                                    {{ category.name }}
                                </router-link>
                            </li>
                            <li class="d-xl-inline-none d-block d-md-none padding-bottom-1 w-100">
                                <router-link class="text-size-14 text-white d-inline-block inter-regular-family text-full-12" to="/blog/" exact-active-class="active-link">
                                    Blog
                                </router-link>
                            </li>
                        </ul>
                    </div>
                    <div class="col-xl-3 col-6 
                    col-sm-4 col-md-4 col-lg-2 ps-xl-5 mt-4 mt-xl-0 mt-md-0">
                        <div class="w-100 d-inline-block 
                        padding-bottom-2">
                            <span class="text-white fw-bold text-size-15 spacing-2 family-guy text-full-15">City
                            </span>
                        </div>
                        <ul class="w-100 d-inline-block ps-0 footer-services">
                            <li
                                v-for="city in footerCitiesToRender"
                                :key="city.id || city.name"
                                class="d-inline-block padding-bottom-1 w-100"
                            >
                                <span class="text-size-14 text-white d-inline-block inter-regular-family text-full-12">
                                    {{ city.name }}
                                </span>
                            </li>
                        </ul>
                    </div>
                    <div class="col-xl-3 col-12 
                    col-sm-8 col-md-8 col-lg-4">
                        <div class="w-100 d-inline-block 
                        padding-bottom-2">
                            <span class="text-white fw-bold text-size-15 spacing-2 family-guy text-full-15">Contact
                            </span>
                        </div>
                        <ul class="w-100 d-inline-block ps-0 footer-services">
                            <li class="d-inline-block padding-bottom-2 w-100">
                                <a class="text-size-14 text-white d-inline-block inter-regular-family text-full-12" href="javascript:void(0)" @click="openCall">
                                    <span class="d-inline-block text-center rounded-5 me-2 call-icon">
                                        <i class="fa fa-phone phone-icon" aria-hidden="true"></i>
                                    </span>
                                    {{ footerContactDisplay }}
                                </a>
                            </li>
                            <li class="d-inline-block padding-bottom-2 w-100">
                                <a class="text-size-14 text-white d-inline-block inter-regular-family text-full-12" :href="`mailto:${footerEmailDisplay}`">
                                    <span class="d-inline-block text-center rounded-5 me-2 call-icon">
                                        <i class="fa fa-envelope margin-top-1" aria-hidden="true"></i>
                                    </span>
                                    {{ footerEmailDisplay }}
                                </a>
                            </li>
                            <li class="d-inline-block padding-bottom-2 w-100">
                                <a class="text-size-14 text-white d-inline-block inter-regular-family text-full-12" href="https://www.google.com/maps/place/Dubai+Pets+Groomer+-+Best+pets+Grooming/@25.2048493,55.2517284,15z/data=!4m10!1m2!2m1!1sDubai+Pets+Groomer+-+Best+pets+Grooming!3m6!1s0x3e5f43dc588c97e5:0x13806c0bee3449ef!8m2!3d25.2048493!4d55.2707828!15sCidEdWJhaSBQZXRzIEdyb29tZXIgLSBCZXN0IHBldHMgR3Jvb21pbmeSAQtwZXRfZ3Jvb21lcuABAA!16s%2Fg%2F11v3q6xnct?entry=ttu" target="_blank">
                                    <span class="d-inline-block text-center rounded-5 me-2 call-icon">
                                        <i class="fa fa-map-marker margin-top-1" aria-hidden="true"></i>
                                    </span>
                                    {{ footerWebsiteName }}
                                </a>
                            </li>
                        </ul>

                    </div>
                </div>
                <div class="row margin-xl-top-3 margin-bottom-3">
                    <div class="col-xl-3 col-12 order-xl-1 order-3 mt-xl-0 mt-3 col-sm-6 col-md-6 col-lg-6 mb-xl-0 mb-2">
                        <div class="w-100 
                        d-inline-block text-xs-center text-sm-center text-md-center mb-xl-0 mb-5">
                            <p class="text-size-14 text-white mb-xl-0 mb-5 medium-family 
                            text-full-11">
                                Copyright © 2025. All rights reserved
                            </p>
                        </div>
                    </div>
                    <div class="col-xl-3 col-12 order-xl-2 order-2 mt-xl-0 mt-3 col-sm-6 col-md-6 col-lg-6">
                        <div class="w-100 
                        d-inline-block text-xs-center text-sm-center text-md-center">
                            <p class="text-size-14 text-white mb-0 medium-family text-full-11">
                                Developed by:<span class="text-orange">MSNSOFT
                                </span>
                            </p>
                        </div>
                    </div>
                    <div class="col-xl-6 col-12 order-xl-3 order-1">
                        <div class="w-100 d-inline-block 
                        terms-service text-xs-center text-sm-center text-md-center">
                        <router-link class="text-size-13 text-white medium-family text-full-11 privacy-content" exact-active-class="active-link" to="/privacy">
                            Privacy Policy 
                            <span class="d-inline-block ms-xl-2 ms-2">I</span>
                        </router-link>
                            <router-link class="text-size-13 text-white ms-xl-2 ms-1 medium-family text-full-11 privacy-content" exact-active-class="active-link" to="/termsCondition">
                                Terms and Conditions
                                <span class="d-inline-block ms-xl-2 ms-1">I</span>
                            </router-link>
                            <router-link class="text-size-13 text-white ms-xl-2 ms-1 medium-family text-full-11 privacy-content" exact-active-class="active-link" to="/refundPolicy">
                                Return and Refund Policy
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
        <div  v-if="$route.path !== '/booking/' && $route.path !== '/date'"  class="w-100 d-xl-none d-block sticky-footer text-center bg-white box-shadow">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="d-flex align-items-center justify-content-between">
                            <router-link class="nav-color text-size-12 inter-regular-family fw-bold" exact-active-class="active-link" to="/">
                                <!-- <i class="fa fa-home text-size-24" aria-hidden="true"></i> -->
                                <img src="@/assets/images/home-bottom-icon.svg" alt="picture" style="height:28px;">
                                <p class="mb-0">Home</p>
                            </router-link>
                            <router-link class="nav-color text-size-12 inter-regular-family fw-bold" exact-active-class="active-link" to="/booking/">
                                <!-- <i class="fa fa-calendar text-size-24" aria-hidden="true"></i> -->
                                <img src="@/assets/images/book-online-bottom-icon.svg" alt="picture" style="height:28px;">
                                <p class="mb-0">Book Online</p>
                            </router-link>
                            <a class="nav-color text-size-12 inter-regular-family fw-bold" href="javascript:void(0)" @click="openWhatsApp">
                                <!-- <i class="fa fa-whatsapp text-black text-size-24" aria-hidden="true"></i> -->
                                <img src="@/assets/images/whatsapp-bottom-icon.svg" alt="picture" style="height:28px;">
                                <p class="mb-0">WhatsApp</p>
                            </a>
                            <!-- <a class="nav-color text-size-12 inter-regular-family fw-bold" href="javascript:void(0)" @click="openCall">
                                <img src="@/assets/images/call-bottom-icon.svg" alt="picture" style="height:28px;">
                                <p class="mb-0">Call</p>
                            </a> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { readWebsiteNameFromStorage } from '@/utils/currentWebsite';
import { withCountryPath } from '@/utils/countryPath';
import {
  readSelectedWebsiteContactRaw,
  normalizeContactForTel,
} from '@/utils/websiteContact';

export default {
    name: 'footerComponent',

    data() {
       return {
        footerWebsiteName: readWebsiteNameFromStorage(),
        footerWebsiteLogo: null,
        footerContact: null,
        footerEmail: null,
        footerFacebook: null,
        footerInstagram: null,
        footerTwitter: null,
        footerCategories: [],
        footerCities: [],
       }
     },
     computed: {
        footerLogoSrc() {
            if (this.footerWebsiteLogo) return this.$getImageUrl(this.footerWebsiteLogo);
            return require('@/assets/images/footer-logo.svg');
        },
        footerContactDisplay() {
            return this.footerContact || '+971 52573 5386';
        },
        footerEmailDisplay() {
            return this.footerEmail || 'lushgroom@gmail.com';
        },
        footerFacebookUrl() {
            return this.footerFacebook || 'https://www.facebook.com/lushgroom/';
        },
        footerInstagramUrl() {
            return this.footerInstagram || 'https://www.instagram.com/lushgroom/';
        },
        footerTwitterUrl() {
            return this.footerTwitter || 'https://www.twitter.com/lushgroom/';
        },
        footerContactTel() {
            return normalizeContactForTel(this.footerContact || readSelectedWebsiteContactRaw());
        },
        footerCitiesToRender() {
            if (Array.isArray(this.footerCities) && this.footerCities.length) return this.footerCities;
            const fallbackName = (this.$countryName || '').toString().trim();
            return fallbackName ? [{ id: 'fallback-country', name: fallbackName }] : [];
        },
     },

methods:{
    footerServiceLink(category) {
      const slug = (category?.slug || '').trim();
      return withCountryPath(slug ? `/services/${slug}/` : '/services/');
    },
    hydrateSelectedWebsiteFromStorage() {
        try {
            const storedWebsite = JSON.parse(localStorage.getItem('selected_website') || 'null');
            if (storedWebsite?.name) this.footerWebsiteName = storedWebsite.name;
            this.footerWebsiteLogo = storedWebsite?.logo || null;
            this.footerContact = storedWebsite?.contact || null;
            this.footerEmail = storedWebsite?.website_email || null;
            this.footerFacebook = storedWebsite?.facebook || null;
            this.footerInstagram = storedWebsite?.instagram || null;
            this.footerTwitter = storedWebsite?.twitter || null;
        } catch (e) {
            // ignore
        }
    },
    async fetchFooterCategories() {
        try {
            const form = new URLSearchParams();
            form.append('website_name', this.activeWebsiteName || '');
            const res = await this.$axios.post('/get-categories-home', form);
            if (res?.data?.status === 'success') {
                this.footerCategories = Array.isArray(res.data.categories) ? res.data.categories : [];
            }
        } catch (e) {
            // fail silently
        }
    },
    async fetchFooterCities() {
        try {
            const form = new URLSearchParams();
            form.append('website_name', this.activeWebsiteName || '');
            const res = await this.$axios.post('/get-cities', form);
            if (res?.data?.status === 'success') {
                this.footerCities = Array.isArray(res.data.cities) ? res.data.cities : [];
            }
        } catch (e) {
            // fail silently
            this.footerCities = [];
        }
    },

    openWhatsApp() {
        this.callClick('whatsapp');
    window.dispatchEvent(new CustomEvent('open-whatsapp-chat'));
  },
    async openCall() {
        // console.log("Call link clicked");
    
        // First, call the API to store the click data
        await this.callClick('call');
    
        // Then open the phone app
        const phoneNumber = this.footerContactTel;
        const telUrl = `tel:${phoneNumber}`;
        window.open(telUrl, "_blank");
      },  
      async callClick(method) {
    //   console.log('Call button clicked');
       try {
        const payload = {
          website_name: this.activeWebsiteName,
          type: method,
          ip: 'call',
        
        };
        const response = await this.$axios.post('/click-count', payload);
        console.log('Response:', response.data);
        
      } catch (err) {
        console.error('Error during call click:', err);
      }
    },

},
mounted() {
    this.hydrateSelectedWebsiteFromStorage();
    this.fetchFooterCategories();
    this.fetchFooterCities();
},
watch: {
    activeWebsiteName() {
        this.hydrateSelectedWebsiteFromStorage();
        this.fetchFooterCategories();
        this.fetchFooterCities();
    },
},
}
</script>

<style scoped>
.text-orange{
    color: #f8721f;
}
</style>
